var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTwitterIcon = function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.888 7.477c.026.328.026.656.026.984C35.914 18.469 27.665 30 12.589 30 7.944 30 3.629 28.758 0 26.602c.66.07 1.294.093 1.98.093 3.832 0 7.36-1.195 10.177-3.234-3.604-.07-6.624-2.25-7.665-5.25.508.07 1.016.117 1.549.117.736 0 1.472-.094 2.157-.258-3.756-.703-6.574-3.75-6.574-7.43v-.093a8.78 8.78 0 003.706.96c-2.208-1.359-3.655-3.679-3.655-6.304a7.08 7.08 0 011.117-3.82c4.035 4.594 10.101 7.593 16.903 7.922a7.917 7.917 0 01-.203-1.735c0-4.172 3.655-7.57 8.198-7.57 2.36 0 4.493.914 5.99 2.39A16.976 16.976 0 0038.883.564c-.609 1.757-1.903 3.234-3.604 4.171A17.519 17.519 0 0040 3.563a16.953 16.953 0 01-4.112 3.914z",
    fill: "#F9BD47"
  })));
};
export default SvgTwitterIcon;